// src/Utils/clearAuthData.js

import axios from 'axios'

// const MIGRATION_KEY = 'auth_migration_v2_done'

const clearBrowserState = () => {
    try {
        const host = window.location.hostname
        const domains = [host, `.${host}`]

        const parts = host.split('.')
        if (parts.length > 2) {
            domains.push(`.${parts.slice(-2).join('.')}`)
        }

        document.cookie.split(';').forEach((c) => {
            const name = c.split('=')[0].trim()
            if (!name) return

            domains.forEach((d) => {
                document.cookie = `${name}=; Path=/; Domain=${d}; Expires=Thu, 01 Jan 1970 00:00:00 GMT`
            })

            document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT`
        })
    } catch (e) {
        console.log({e})
    }

    try { localStorage.clear() } catch (e) {
        console.log({e})
    }
    try { sessionStorage.clear() } catch (e) {
        console.log({e})
    }
}

const clearAuthData = async () => {
    // if (localStorage.getItem(MIGRATION_KEY) === '1') return

    try {
        await axios.post(
            `${process.env.REACT_APP_URL}v1/cookies-delete`,
            {},
            { withCredentials: true }
        )
    } catch (e) {
        console.log({ e })
    }

    clearBrowserState()

    // localStorage.setItem(MIGRATION_KEY, '1')
}

export default clearAuthData